(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ace-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const SECTION_SELECTOR = '[data-ace-hero]';

    /**
     * @param {HTMLElement} root
     */
    function initAceHero(root) {
      if (root.dataset.aceHeroInitialized === 'true') {
        return;
      }

      const carousel = root.querySelector('[data-ace-hero-carousel]');
      const cardBtns = root.querySelectorAll('[data-ace-hero-card-btn]');
      const dots = root.querySelectorAll('[data-ace-hero-dot]');
      const ctas = root.querySelectorAll('[data-ace-hero-cta]');
      const mediaFrame = root.querySelector('[data-ace-hero-media-frame]');
      const cardsScroller = root.querySelector('.ace-hero__cards');
      const autoplayToggle = root.querySelector('[data-ace-hero-autoplay-toggle]');

      if (!carousel || cardBtns.length === 0) {
        return;
      }

      root.dataset.aceHeroInitialized = 'true';

      let active = 0;
      let renderedMediaIndex = active;
      let renderedMediaKey = mediaFrame ? mediaFrame.dataset.aceHeroMediaKey || '' : '';
      let autoplayTimer = null;
      let userPaused = false;
      const autoplay = carousel.dataset.aceHeroAutoplay === 'true';
      const autoplayInterval = parseInt(carousel.dataset.aceHeroAutoplayInterval || '5000', 10);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const initialActive = root.querySelector('.ace-hero__card--active');
      if (initialActive) {
        const card = initialActive.closest('[data-ace-hero-card]');
        if (card) {
          active = parseInt(card.dataset.productIndex || '0', 10);
          renderedMediaIndex = active;
        }
      }

      function syncMedia(index) {
        if (!mediaFrame || renderedMediaIndex === index) {
          return;
        }

        const template = root.querySelector(`[data-ace-hero-media-template="${index}"]`);
        if (!(template instanceof HTMLTemplateElement)) {
          return;
        }

        // Same image as currently shown (e.g. shared fallback background):
        // skip the swap entirely so the frame never fades to white.
        const nextKey = template.dataset.aceHeroMediaKey || '';
        if (nextKey && nextKey === renderedMediaKey) {
          renderedMediaIndex = index;
          return;
        }

        const nextMedia = template.content.cloneNode(true);
        if (!nextMedia.hasChildNodes()) {
          return;
        }

        renderedMediaIndex = index;
        renderedMediaKey = nextKey;
        mediaFrame.classList.add('ace-hero__media-frame--swapping');
        window.setTimeout(() => {
          mediaFrame.replaceChildren(nextMedia);
          window.requestAnimationFrame(() => {
            mediaFrame.classList.remove('ace-hero__media-frame--swapping');
          });
        }, reducedMotion ? 0 : 140);
      }

      function sync(scrollActiveCard) {
        cardBtns.forEach((btn, i) => {
          const on = i === active;
          btn.classList.toggle('ace-hero__card--active', on);
          btn.setAttribute('aria-current', on ? 'true' : 'false');
        });

        dots.forEach((dot, i) => {
          const on = i === active;
          dot.classList.toggle('ace-hero__dot--active', on);
          dot.setAttribute('aria-pressed', on ? 'true' : 'false');
        });

        const row = cardBtns[active]?.closest('[data-ace-hero-card]');
        if (row) {
          syncMedia(active);

          const url = row.dataset.productUrl;
          ctas.forEach((cta) => {
            if (cta instanceof HTMLAnchorElement && url) {
              cta.setAttribute('href', url);
            }
          });

          if (scrollActiveCard && cardsScroller) {
            cardsScroller.scrollTo({
              left: row.offsetLeft - cardsScroller.clientWidth / 2 + row.clientWidth / 2,
              behavior: reducedMotion ? 'auto' : 'smooth',
            });
          }
        }
      }

      function goTo(index, wrap, scroll) {
        let next = index;
        if (wrap) {
          next = (index + cardBtns.length) % cardBtns.length;
        } else {
          next = Math.min(Math.max(0, index), cardBtns.length - 1);
        }
        active = next;
        sync(scroll !== false);
      }

      function stopAutoplay() {
        if (autoplayTimer) {
          window.clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }

      function startAutoplay() {
        stopAutoplay();

        if (!autoplay || reducedMotion || cardBtns.length < 2 || userPaused) {
          return;
        }

        autoplayTimer = window.setInterval(() => {
          goTo(active + 1, true);
        }, Number.isNaN(autoplayInterval) ? 5000 : autoplayInterval);
      }

      cardBtns.forEach((btn, i) => {
        // Cards are links: a click navigates straight to the product page.
        // Hover/focus only previews the slide (background, label, CTA href)
        // without scrolling the rail.
        btn.addEventListener('mouseenter', () => {
          goTo(i, false, false);
        });
        btn.addEventListener('focus', () => {
          goTo(i, false, false);
        });
      });

      dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          goTo(i);
          startAutoplay();
        });
      });

      if (autoplayToggle) {
        autoplayToggle.addEventListener('click', () => {
          userPaused = !userPaused;
          autoplayToggle.classList.toggle('is-paused', userPaused);
          autoplayToggle.setAttribute('aria-pressed', userPaused ? 'false' : 'true');
          const label = userPaused
            ? autoplayToggle.dataset.labelPlay
            : autoplayToggle.dataset.labelPause;
          if (label) {
            autoplayToggle.setAttribute('aria-label', label);
          }
          if (userPaused) {
            stopAutoplay();
          } else {
            startAutoplay();
          }
        });
      }

      carousel.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          goTo(active + 1);
        }
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          goTo(active - 1);
        }
      });

      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
      root.addEventListener('focusin', stopAutoplay);
      root.addEventListener('focusout', startAutoplay);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stopAutoplay();
        } else {
          startAutoplay();
        }
      });

      sync(false);
      startAutoplay();
    }

    function boot() {
      document.querySelectorAll(SECTION_SELECTOR).forEach(initAceHero);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
